<template>
  <!--  -->
  <div class="goods room__block" @click.stop="$emit('close')">
    <div v-show="listShow" class="goods-list__panel">
      <div class="goods-list__header" @click.stop="">
        <!-- <div class="goods-list__header_business">
          <img class="goods-list__header_business_logo" :src="business.logo" />
          <span class="goods-list__header_business_name">{{
            business.name
          }}</span>
        </div> -->
        <div class="goods-list__header_business_title">Product List</div>
        <img
          class="goods-list__header_close global_pointer"
          @click="$emit('close')"
          :src="require('@/assets/imgs/close.png')"
        />
      </div>

      <div class="goods-list__body">
        <div
          class="goods-list__item"
          v-for="(item, index) in goods"
          :key="item.id"
        >
          <div class="good__unit">
            <div class="good__content" @click.stop="tapGoods(item.id)">
              <div class="goods-list__poster global_pointer">
                <div class="goods-list__poster-num">{{ goods.length - index }}</div>
                <img :src="item.merchandiseImg.url" />
                <div
                  class="goods-list__poster-sellout"
                  v-if="item.notice.hasStock == 0"
                >
                  <span>{{ $t("message.goods.sellOut") }}</span>
                </div>
              </div>

              <div class="goods-list__info">
                <div class="goods-list__name">{{ item.merchandiseName }}</div>

                <div class="goods-list__price">
                  <span
                    class="goods-list__price-text"
                    v-if="item.dollarAmountMoney"
                    >{{ item.dollarAmountMoney.symbol
                    }}{{ $priceSeparator(item.dollarAmountMoney.number) }}</span
                  >
                  <span class="goods-list__price-text" v-else
                    >{{ item.miniAmountMoney.symbol
                    }}{{ $priceSeparator(item.miniAmountMoney.number) }}</span
                  >
                </div>

                <div class="goods-list__pricevalue">
                  <!-- 中文 环境不显示划价 -->
                  <template v-if="item.userDiscountStr">
                    <span
                      v-if="
                        item.dollarShelfOrgAmountMoney && $i18n.locale === 'en'
                      "
                      class="goods-list__pricevalue-value"
                    >
                      {{ item.dollarShelfOrgAmountMoney.symbol
                      }}{{
                        $priceSeparator(item.dollarShelfOrgAmountMoney.number)
                      }}
                    </span>
                    <span
                      v-else-if="
                        item.miniOrgAmountMoney && $i18n.locale === 'en'
                      "
                      class="goods-list__pricevalue-value"
                    >
                      {{ item.miniOrgAmountMoney.symbol
                      }}{{ $priceSeparator(item.miniOrgAmountMoney.number) }}
                    </span>
                  </template>
                  <div
                    v-if="item.userDiscountStrEn && item.payCustomType != 1"
                    class="goods-list__pricevalue-off"
                  >
                    {{ item.userDiscountStrEn }}
                  </div>
                  <div
                    v-else-if="item.userDiscountStr && item.payCustomType != 1"
                    class="goods-list__pricevalue-off"
                  >
                    {{ item.userDiscountStr }}
                  </div>
                  <div v-else></div>
                </div>
                <!-- item.payCustomType ==1 是新客专享， 此时不显示折扣价格 -->

                <!-- 不区分中英文  - 美元金额 + 新客专项  -->
                <template v-if="item.payCustomType == 1">
                  <div class="goods-list__newuseronly">
                    {{ $t("message.goods.NewUserOnly") }}
                  </div>
                </template>
                <template v-else>
                  <!-- 英文 环境不显示上架币种 只显示划价的上架币种 -->
                  <span
                    class="mini_shelf_price"
                    v-if="$i18n.locale !== 'en' && item.minShelfAmountMoney"
                    >&nbsp;({{
                      `${item.minShelfAmountMoney.symbol}${$currencyFormatter(
                        item.minShelfAmountMoney.number
                      )}`
                    }})</span
                  >
                  <!-- v-if="item.discounted !== 0" -->
                </template>
              </div>
            </div>
            <div
              class="goods-list__btn"
              :class="{ 'goods-list__btn-content-end': liveStatus != 2 }"
            >
              <template
                v-if="
                  liveStatus != 2 &&
                  item.shelfStatus == 0 &&
                  item.notice.hasStock == 0
                "
              >
                <div @click.stop class="goods-list__btn-buy">
                  {{ $t("message.goods.soldOut") }}
                </div>
              </template>
              <template v-else>
                <div
                  v-if="liveStatus == 2"
                  @click.stop="askHost(index + 1)"
                  class="goods-list__btn-msg global_pointer"
                >
                  {{ $t("message.goods.askHost") }}
                </div>
                <div
                  v-if="item.notice.hasStock !== 0 && item.shelfStatus !== 0"
                  @click.stop="changeCurrent(item)"
                  class="goods-list__btn-buy global_pointer"
                >
                  {{ $t("message.goods.popListAddCart") }}
                </div>
                <div
                  v-else-if="liveStatus != 2"
                  @click.stop="messageMe(item)"
                  class="goods-list__btn-msg global_pointer"
                >
                  {{ $t("message.im.messageMe") }}
                </div>
                <div v-else class="goods-list__btn-buy goods-list__btn-gray">
                  {{ $t("message.goods.sellOut") }}
                </div>
              </template>
            </div>
          </div>
          <div class="goods-list__line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { priceSeparator } from "@/utils/formatUtil";
import api from "@/api/api_list";
import { CURRENT_HOST_NAME } from "@/utils/index";
export default {
  props: {
    goods: {
      type: Array,
      default: () => {
        return [];
      },
    },
    liveId: {
      type: String,
      default: "",
    },
    business: {
      type: Object,
      default: () => {
        return {};
      },
    },
    liveStatus: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      listShow: true,
    };
  },
  methods: {
    askHost(index) {
      this.$emit(
        "askHost",
        this.$isZh ? index : `${this.$t("message.goods.askHostPush")} ${index}`
      );
    },
    changeCurrent(item) {
      if (!this.$isLogin()) {
        return;
      }

      this.$shareGuide.open(); 

      // // 为了兼容服务端接口字段 - sku弹窗要接收shelfAmountMoney字段，而这个字段跟minShelfAmountMoney是同一个意思
      // if (item.minShelfAmountMoney && !item.shelfAmountMoney) {
      //   item.shelfAmountMoney = item.minShelfAmountMoney;
      // }

      // const that = this;

      // this.$sku.open({
      //   goods: item,
      //   business: this.business,
      //   liveId: this.liveId,
      //   closeCallback: () => {
      //     that.listShow = true;
      //   },
      // });

      this.listShow = false;
      this.$emit("close");
    },
    tapGoods(id) {
      this.$emit("tapGoods", id);
    },
    async messageMe(item) {
      if (!item.userLikeMdse) {
        const { code } = await api.merchandise_like({
          merchandiseId: item.id,
        });
        if (code === 0) {
          item.userLikeMdse = 1;
          this.$toast(this.$t("message.goods.collectTip"));

          if (item.netAccount) {
            this.$store.dispatch("sendMsg", {
              type: "text",
              scene: "p2p",
              to: item.netAccount,
              text: this.$t("message.im.iWantMessage"),
            });

            const { symbol, number } = item.miniAmountMoney;
            let data = {
              type: 7,
              data: {
                title: item.merchandiseName,
                linkUrl: item.id,
                imageUrl: item.merchandiseImg.url,
                describe: symbol + priceSeparator(Number(number).toFixed(2)),
                liveId: this.liveId,
                orderNo: "",
                orderId: "",
              },
            };
            this.$store.dispatch("sendMsg", {
              type: "custom",
              scene: "p2p",
              to: item.netAccount,
              content: data,
            });
          }
        }
      }

      this.customerService(item);
    },

    customerService(item) {
      if (item.netAccount) {
        this.$router.push({
          path: "/nimChat",
          query: { sessionId: `p2p-${item.netAccount}` },
        });
      } else {
        // 中文环境联系客服、英文环境发邮件
        if (this.$isZh) {
          const { symbol, number } = this.miniAmountMoney;

          let data = {
            goodsName: item.merchandiseName,
            goodsId: item.id,
            goodsImageUrl: item.merchandiseImg.url,
            goodsMoneySymbol: symbol,
            goodsMoneyNumber: priceSeparator(Number(number).toFixed(2)),
            topicId: this.liveId,
            url: window.location.href,
          };
          // 2.21版本不在使用七鱼客服
          //   this.qiyuKF(data);
          return;
        }
        let host = `https://m-uat.${CURRENT_HOST_NAME}/uat-en`;
        if (process.env.NODE_ENV === "production") {
          host =
            process.env.VUE_APP_HOST || `https://m.${CURRENT_HOST_NAME}/en`;
        }
        let url = `${host}/app/goods_detail?goodsId=${item.id}&liveId=${this.liveId}`;

        let subject = item.merchandiseName;
        let email = "CustomerServices@shopshopslive.com";
        api.create_short_url({ content: url }).then((res) => {
          if (res.code === 0) {
            let shortUrl = res.result;
            shortUrl = encodeURIComponent(shortUrl);

            let body = `${shortUrl}`;
            window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mini_shelf_price {
  color: #aaa;
  font-size: 12px;
  font-weight: normal;
  font-family: "TradeGothicLT";
}

.warp() {
  overflow: hidden;
  text-overflow: ellipsis;
  // white-space: nowrap;
  word-wrap: normal;
}
.scroll() {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;
}
.goods-list,
.good {
  font-weight: normal;
  &__panel {
    width: 375px;
    background: #fef7f0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    max-height: 396px;
    position: absolute;
    left: 50%;
    bottom: 0;
    z-index: 100;
    transform: translateX(-50%);
    box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.1);
  }
  &__header {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &_close {
      position: absolute;
      width: 26px;
      right: 12px;
    }
    &_business {
      // margin-left: 16px;
      height: 25px;
      display: flex;
      align-items: center;
      &_title {
        font-size: 16px;
        // font-weight: bold;
        color: black;
        font-family: "Approach-Medium";
      }
      &_logo {
        width: 24px;
        margin-right: 4px;
        border-radius: 50%;
      }
      &_name {
        font-size: 15px;
        font-weight: normal;
        color: #333333;
        font-family: "Approach-Medium";
      }
    }
  }
  &__body {
    width: 100%;
    max-height: 346px;
    box-sizing: border-box;
    // padding: 0 16px;
    margin-top: 16px;
    text-align: left;
    .scroll();
  }
  &__item {
    margin-bottom: 18px;
  }
  &__unit {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 18px;
    padding: 0 16px;
  }
  &__line {
    background: #c2c3c4;
    height: 1px;
    width: 100%;
    margin-left: 16px;
  }
  &__content {
    height: 100px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
  }
  &__poster {
    width: 100px;
    height: 100px;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border:2px solid rgba(243,243,243, 0.8);
    // border:1px solid #f3f3f3;

    &-num {
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 21px;
      line-height: 21px;
      background: rgba(13, 14, 19, 0.45);

      border-radius: 4px 0;
      font-size: 12px;
      font-weight: normal;
      color: white;
      text-align: center;
      font-family: "approach-mono-medium";
    }
    img {
      width: 100%;
      border-radius: 8px;
    }
    &-sellout {
      display: flex;
      position: absolute;
      left: 0;
      bottom: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      justify-content: center;
      align-items: center;
      span {
        line-height: 25px;
        font-size: 14px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        font-family: Approach-Bold;
      }
    }
  }
  &__info {
    flex: 1;
    box-sizing: border-box;
    padding-left: 12px;
  }
  &__name {
    font-size: 13px;
    font-weight: 600;
    color: #0d0e13;
    margin-bottom: 8px;
    font-family: "TradeGothicLT";
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    .warp();
  }
}
.goods-list {
  &__newuseronly {
    padding: 0 5px;
    color: #0d0e13;
    border-radius: 11px;
    font-size: 9px;
    line-height: 21px;
    margin-top: 5px;
    background: #c8f2f6;
    min-width: 108px;
    min-height: 21px;
    text-align: center;
    font-weight: bold;
  }
  &__price {
    &-text {
      font-size: 14px;
      font-weight: 600;
      color: #0d0e13;
      font-family: "approach-mono-medium";
    }
  }
  &__pricevalue {
    display: flex;
    flex-direction: row;
    &-value {
      font-size: 11px;
      font-weight: normal;
      color: #c2c3c4;
      text-decoration: line-through;
      display: inline-block;
      margin-left: 4px;
    }
    &-off {
      min-width: 36px;
      height: 11px;
      line-height: 11px;
      box-sizing: border-box;
      border-radius: 11px;
      font-size: 11px;
      font-weight: 600;
      color: #f37c47;
      text-align: center;
      display: inline-block;
      margin-left: 7px;
      font-family: "approach-mono-medium";
    }
  }

  &__btn {
    width: 100%;
    display: flex;
    height: 26px;
    align-items: center;
    // padding-top: 5px;
    justify-content: space-between;
    &-content-end {
      justify-content: flex-end;
    }
    &-msg {
      min-width: 160px;
      box-sizing: border-box;
      padding: 0 12px;
      // margin-left: 10px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      background: #fef7f0;
      border: 1px solid #0d0e13;
      border-radius: 14px;
      font-size: 12px;
      font-weight: normal;
      color: #0d0e13;
      font-family: "TradeGothicLT";
    }
    &-buy {
      min-width: 160px;
      box-sizing: border-box;
      padding: 0 12px;
      // margin-left: 10px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      background: #0d0e13;
      border: 1px solid #0d0e13;
      border-radius: 14px;
      font-size: 12px;
      font-weight: normal;
      color: white;
      font-family: "TradeGothicLT";
    }
    &-gray {
      opacity: 0.35;
      background: #000000;
    }
  }
}
.good {
  &__price {
    margin-bottom: 8px;
    &-text {
      font-size: 20px;
      font-weight: 600;
      color: #345547;
    }
  }
  &__value {
    font-size: 14px;
    font-weight: normal;
    color: #666666;
    line-height: 18px;
    text-decoration: line-through;
  }
  &__sku {
    height: 1.54erm;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    &_name {
      flex: 1;
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 15px;
      font-weight: normal;
      color: #000000;
    }
    &_arrow {
      margin-right: 15px;
      width: 17px;
      height: 16px;
      background: url("../../assets/imgs/goods/select.png") center no-repeat;
      background-size: 100% 100%;
    }
  }
  &__selector {
    width: 148px;
    height: 46px;
    border-radius: 23px;
    border: 1px solid #000000;
    display: flex;
    align-items: center;
    position: relative;
    > ul {
      padding: 0;
      position: absolute;
      left: -1px;
      top: 50%;
      width: 150px;
      background: #ffffff;
      border: 1px solid #000000;
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      border-top: none;
      max-height: 145px;
      .scroll();
      > li {
        width: 100%;
        height: 46px;
        line-height: 46px;
        text-align: center;
      }
    }
  }
  &__btn {
    margin-top: 21px;
    width: 100%;
    height: 46px;
    line-height: 46px;
    font-size: 15px;
    border-radius: 23px;
    text-align: center;
  }
  &__buy {
    background: #222222;
    color: #ffffff;
  }
  &__cart {
    background: #f2f2f2;
    color: #000000;
    margin-bottom: 21px;
  }
}
</style>